<template>
  <v-container class="pa-0 ma-0">
    <v-card width="100%" class="mx-auto" @click="open">

      <v-card-text class="pa-0">
        <v-container class="ma-0 pa-0 px-2">
          <v-row no-gutters align="center" justify="space-around">
            <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9">
              <div style="min-height: 116px;">
                <div class="body-1 pt-4 pb-2">{{ calendar.speciality }}</div>
                <div class="subtitle-2 font-weight-black">{{ calendar.professional }}</div>
                <!-- <div>{{ `${(calendar.attendCovenant) ? 'Atende meu convênio' : ''}` }}</div> -->
                <div>{{ calendar.attendCovenant }}</div>

                <div v-if="calendar.dynamicDistance" class="pt-2">
                  Distância aproximada: {{ calendar.dynamicDistance | km }}
                </div>

                <div v-if="calendar.nextSchedules" class="py-2">
                  <div>Próxima data disponível:</div>
                  <div>{{ calendar.nextSchedules | date }}</div>
                </div>
                <div v-if="calendar.nextSchedules" >
                  <div>Total de horários:</div>
                  <div>{{ calendar.totalTimes }}</div>
                </div>
              </div>
            </v-col>
            <v-col no-gutters xl="2" lg="2" md="2" sm="2" cols="3">
              <v-list-item-avatar :size="($vuetify.breakpoint.xsOnly) ? 48 : 60" color="blue">
                <v-img :src="calendar.professionalAvatar"></v-img>
              </v-list-item-avatar>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>

        <v-spacer></v-spacer>

        <v-btn text icon @click.stop="open">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    calendar: null,
    geolocation: null,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.calendar = this.value;
  },
  destroyed() {
    this.confirmRemove = false;
  },
  methods: {
    open() {
      this.$emit('open', this.calendar.calendarId);
    },
  },
  watch: {
    value(vl) {
      this.calendar = vl;
    },
  },
};
</script>
